import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { AVATAR_GROUP } from "./constants";
export var pt = /*#__PURE__*/_defineProperty({}, AVATAR_GROUP, {
  MEMBERS: 'Miembros'
});